jQuery(document).ready(function ($) {

    setInterval(function () {
        moveRight();
    }, 25000);
  
	var slideCount = $('.ScreenSlider ul li').length;
	var slideWidth = $('.ScreenSlider ul li').width();
	var slideHeight = $('.ScreenSlider ul li').height();
	var sliderUlWidth = slideCount * slideWidth;
	
	$('.ScreenSlider').css({ width: slideWidth, height: slideHeight });
	
	$('.ScreenSlider ul').css({ width: sliderUlWidth, marginLeft: - slideWidth });
	
    $('.ScreenSlider ul li:last-child').prependTo('.ScreenSlider ul');
  
    function moveLeft() {
        $('.ScreenSlider ul').animate({
            left: + slideWidth,
        }, 25000, function () {
            $('.ScreenSlider ul li:last-child').prependTo('.ScreenSlider ul');
            $('.ScreenSlider ul').css('left', '');
        });
    };

    function moveRight() {
        $('.ScreenSlider ul').animate({
            left: - slideWidth ,
        }, 3000, function () {
            $('.ScreenSlider ul li:first-child').appendTo('.ScreenSlider ul');
            $('.ScreenSlider ul').css('left', '').hide().fadeIn('slow');
        });
    };

    $('a.control_prev').click(function () {
        moveLeft();
    });

    $('a.control_next').click(function () {
        moveRight();
    });
  
 
  

});    